
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/v/[venue]",
      function () {
        return require("private-next-pages/v/[venue]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/v/[venue]"])
      });
    }
  